import api from 'app/shared/utils/api';
import AddressDetails from 'app/shared/model/AddressDetails';
import AutoCompleteAddresses from 'app/shared/model/AutoCompleteAddresses';
import Constants from 'app/shared/constants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import promise from 'promise';

// model
import ErrorRMW from 'app/shared/model/ErrorRMW';

// service
import appLogger from 'app/shared/loggers/appLogger';

const AddressActions = {
    autocomplete(partialAddress) {
        return dispatch => dispatch(api.properties.address.autocomplete(partialAddress))
            .then((response = {}) => {
                if (response.success && response.response) {
                    const autoCompleteAddressModel = AutoCompleteAddresses(response.response);

                    dispatch({
                        type: Constants.ADDRESS_AUTO_COMPLETE,
                        payload: {
                            addressList: autoCompleteAddressModel.addresses,
                        },
                    });
                }
            });
    },
    getComps(zpid) {
        return dispatch => dispatch(api.properties.address.comps(zpid))
            .then((response) => {
                if (response.success && response.response) {
                    return response.response;
                }
                return promise.reject(response.error);
            });
    },
    getDetails(addressData) {
        return (dispatch, getState) => dispatch(api.properties.address.details(addressData))
            .then((response) => {
                const { error: errorRMWModel, success } = response;

                if (success && response.response) {
                    // if status is failure
                    if (response.response.status &&
                            response.response.status.toLowerCase() === Constants.ADDRESS_STATUS_FAILURE.toLowerCase()) {
                        // cast as ErrorRMW
                        const serviceErrorAsRMWModel = ErrorRMW({
                            message: 'Comps not available for this address.',
                        });

                        return promise.reject(serviceErrorAsRMWModel);
                    }
                    const addressDetailsModel = AddressDetails(response.response);

                    // update redux store
                    dispatch({
                        type: DispatchConstants.ADDRESS_DETAILS,
                        payload: addressDetailsModel,
                    });

                    return addressDetailsModel;
                }
                return promise.reject(errorRMWModel);
            })
            .catch((errorRMWModel) => {
                // dispatch
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'AddressActions.getDetails',
                    user: getState().user,
                });

                return promise.reject(errorRMWModel);
            });
    },
    verify(addressData) {
        return dispatch => dispatch(api.properties.address.verification({
            address: addressData.address,
            unit: addressData.unit,
        })).then((response) => {
            if (response.success && response.response) {
                return response.response;
            }
            return promise.reject(response.error);
        });
    },
    getRestrictions(addressData) {
        const {
            address,
            unit,
            listingTypeCode,
            listingAlias,
            propertyTypeCode,
        } = addressData;
        return dispatch => dispatch(
            api.properties.locations.getRestrictions({
                address,
                unit,
                listingTypeCode,
                listingAlias,
                propertyTypeCode,
            })
        )
            .then((response) => {
                const { error: errorRMWModel, success } = response;

                if (success && response.response) {
                    return response.response;
                }
                return promise.reject(errorRMWModel);
            })
            .catch((errorRMWModel) => {
                global.TEMPORARY_global_logger.error(errorRMWModel);
                return promise.reject(errorRMWModel);
            });
    },
};

export default AddressActions;
